import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Jurisdiction } from '../../models/jurisdiction';

@Component({
  selector: 'xp-configuration-dialog',
  templateUrl: './configuration-dialog.component.html',
  styleUrl: './configuration-dialog.component.scss'
})
export class ConfigurationDialogComponent {
    form: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<ConfigurationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: Jurisdiction,
        private fb: FormBuilder
    ) {
        this.form = this.fb.group({
            id: [data.id],
            jurisdictionName: [data.jurisdictionName],
            uboPercentage: [data.uboPercentage, [Validators.required, Validators.pattern(/^-?\d+(\.\d{0,2})?$/)]],
            fallbackMatterId: [data.fallbackMatterId, [Validators.required, Validators.pattern(/^\d+$/)]],
            individualCharge: [data.individualCharge, [Validators.required, Validators.pattern(/^-?\d+(\.\d{0,2})?$/)]],
            companyCharge: [data.companyCharge, [Validators.required, Validators.pattern(/^-?\d+(\.\d{0,2})?$/)]]
        });
    }

    save(): void {
        if (this.form.valid) {
            this.dialogRef.close(this.form.value);
        }
        else {
            this.form.markAllAsTouched();
        }
    }
}
